export enum CacheStorageKeys {
    StaleWhileRevalidate = 'stale-while-revalidate',
    NetworkFirst = 'network-first',
}
